export const getImagesList = (files: FileList): { src: string; file: File }[] => {
  const imagesList = [];
  for (let i = 0; i < files.length; i++) {
    imagesList.push({ file: files[i], src: URL.createObjectURL(files[i]) });
  }
  return imagesList;
};
